import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-modal',
  templateUrl: './test-modal.component.html',
  styleUrls: ['./test-modal.component.scss']
})
export class TestModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  onClose() {
    console.log("close");
  }

  onUndo() {
      console.log("undo");
  }

}
